import { AnalyticsNumBedroomType } from '@zg-rentals/ts-customer-analytics-client';
import type { CustomerAnalyticsInsightsMarketPriceCompsDto } from '@zg-rentals/ts-customer-analytics-client';
import { COMPETITORS_COLORS } from '../../../../SelectedPropertyMap/SelectedPropertyMap.config';

export const PORTFOLIO_COLOR = '#0D4599';
export const MARKET_AVG_COLOR = '#DDDDE1';
export const MAX_COMPETITORS = 5;

export const numBedsToAnalyticsNumBedroomType = (numBeds: number): AnalyticsNumBedroomType => {
  switch (numBeds) {
    case 0:
      return AnalyticsNumBedroomType.STUDIO;
    case 1:
      return AnalyticsNumBedroomType.ONE_BEDROOM;
    case 2:
      return AnalyticsNumBedroomType.TWO_BEDROOM;
    case 3:
      return AnalyticsNumBedroomType.THREE_BEDROOM;
    case 4:
      return AnalyticsNumBedroomType.FOUR_PLUS_BEDROOM;
    default:
      return AnalyticsNumBedroomType.ALL;
  }
};

export const bedroomSelectOptions = [
  { value: 0, label: 'Studio' },
  { value: 1, label: '1 Bed' },
  { value: 2, label: '2 Beds' },
  { value: 3, label: '3 Beds' },
  { value: 4, label: '4+ Beds' },
  { value: 5, label: 'All Beds' },
];

export const getAllCompetitorNames = (
  priceComps: Array<CustomerAnalyticsInsightsMarketPriceCompsDto> | undefined,
): Array<string> => {
  if (!priceComps) return [];
  const names: Array<string> = [];
  priceComps.forEach((monthComps) => {
    monthComps.comps.forEach((comp) => {
      if (!names.includes(comp.listingName)) {
        names.push(comp.listingName);
      }
    });
  });
  return names;
};

export const getCompetitorNames = (
  priceComps: Array<CustomerAnalyticsInsightsMarketPriceCompsDto> | undefined,
): Array<string> => {
  return getAllCompetitorNames(priceComps).slice(0, MAX_COMPETITORS);
};

export const getCompsColorMapping = (
  compNames: Array<string>,
  selectedPropertyName?: string,
): Record<string, string> => {
  const mapping: Record<string, string> = {};
  if (selectedPropertyName) {
    mapping[selectedPropertyName] = PORTFOLIO_COLOR;
  }
  const competitorColors = COMPETITORS_COLORS.filter((c) => c !== PORTFOLIO_COLOR);
  let colorIndex = 0;
  compNames.forEach((name) => {
    if (name !== selectedPropertyName) {
      mapping[name] = competitorColors[colorIndex] || '#000';
      colorIndex++;
    }
  });
  return mapping;
};

export const numBedsToLabel = (numBeds: number): string => {
  return bedroomSelectOptions.find((opt) => opt.value === numBeds)?.label ?? 'All Beds';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CompsMonthTick = (props: any) => {
  const { x, y, payload } = props;
  const value = String(payload.value);
  const parts = value.split(' ');
  const month = parts[0] ?? value;
  const year = parts[1] ?? '';

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
        {month}
      </text>
      <text x={0} y={18} dy={16} textAnchor="middle" fill="#666">
        {year}
      </text>
    </g>
  );
};
